<script setup lang="ts">
import type { CurrentMonthPastDayTile } from '../models';

interface CurrentMonthPastDayTileViewProps {
  calendarTile: CurrentMonthPastDayTile;
}

const props = defineProps<CurrentMonthPastDayTileViewProps>();
</script>

<template>
  <div class="current-month-past-day-tile-view">
    {{ props.calendarTile.text }}
    <div class="price-placeholder" />
  </div>
</template>

<style scoped lang="scss">
@import '../styles/price_calendar_mixins';

.current-month-past-day-tile-view {
  width: var(--calendar-tile-size);
  height: var(--calendar-tile-size);

  color: var(--calendar-tile-past-day-font-color);
  @include calendar-tile-day-font;
  cursor: not-allowed;

  display: flex;
  gap: var(--calendar-tile-day-price-gap);
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .price-placeholder {
    height: var(--calendar-price-placeholder-height);
  }
}
</style>
